import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MasterPageComponent } from '../../../components/page/master-page/master-page.component'
import { LABEL_EN,LABEL_TH } from '../../../mokup/label';
import { ORG_EN,ORG_TH,BRANCH } from '../../../mokup/branch';
declare let jQuery: any;



@Component({
selector: "app-footer",
templateUrl: "./footer.component.html",
encapsulation: ViewEncapsulation.None,
})
export class FooterComponent extends MasterPageComponent {
    menu = this.fetchMenu()
    textLabel = this.loadTextLabel()
    org = {}
    branchList = BRANCH;


ngOnInit()  {
    this.fetchData()
}
ngAfterViewInit(){
    this.fetchData()
    this.initIsotope();
}

fetchData(){
    let languageEN = this.changeLanguage();
    if (languageEN) {
      this.org = ORG_EN;
    }else{
      this.org = ORG_TH;
    }

  }

  initIsotope() {

    //parallax
if (jQuery().parallax) {
    jQuery('.parallax').parallax("50%", 0.01);
}

//prettyPhoto
if (jQuery().prettyPhoto) {
    jQuery("a[data-gal^='prettyPhoto']").prettyPhoto({
        hook: 'data-gal',
        theme: 'facebook' /* light_rounded / dark_rounded / light_square / dark_square / facebook / pp_default*/
    });
}

    if (jQuery().jflickrfeed) {
        var $flickr = jQuery("#flickr");
        if ( $flickr.length ) {
            if ( ! ( $flickr.hasClass('flickr_loaded') ) ) {
                $flickr.jflickrfeed({
                    flickrbase: "http://api.flickr.com/services/feeds/",
                    limit: 8,
                    qstrings: {
                        id: "131791558@N04"
                    },
                    itemTemplate: '<a href="{{image_b}}" data-gal="prettyPhoto[pp_gal]"><li><img alt="{{title}}" src="{{image_s}}" /></li></a>'
                }, function(data) {
                    $flickr.find('a').prettyPhoto({
                        hook: 'data-gal',
                        theme: 'facebook'
                    });
                }).addClass('flickr_loaded');
            }
        }
    }
}

}



// WEBPACK FOOTER //
// ./src/app/theme/layouts/footer/footer.component.ts